/**
 * Убирает origin у абсолютного URL (как в монолите).
 */
export const withoutDomain = (url: string | undefined | null): string => {
  if (!url) {
    return '';
  }

  try {
    const { pathname, search, hash } = new URL(url);

    return `${pathname}${search}${hash}`;
  } catch {
    return url;
  }
};
